import { CurrencyDisplay } from '@/lib/components';
import { Divider } from 'antd';
import { getCheckedInvoiceSummary } from '../_helpers/inPaymentPageHelper';

export type CheckedInvoiceSummary = ReturnType<typeof getCheckedInvoiceSummary>;

export const PaymentSelectionSummary = ({
  summary,
}: {
  summary: CheckedInvoiceSummary;
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <span>
        Aantal geselecteerde betaalregels: {summary.partialPaymentCount}
      </span>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
        <span>Totaal bedrag betaalbestand:</span>
        <CurrencyDisplay amount={summary.totalValue} />
      </div>
    </div>
  );
};

export const PaymentConfirmSummary = ({
  summary,
}: {
  summary: CheckedInvoiceSummary;
}) => {
  return (
    <div>
      <span>Totaal</span>
      <Divider
        style={{
          marginTop: 0,
          marginBottom: 15,
          borderWidth: '3px',
        }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span>Betalingen: </span>
        {summary.invoiceCount}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span>Bedrag: </span>
        <CurrencyDisplay amount={summary.totalValue} />
      </div>
    </div>
  );
};
